import { supabaseClient } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { Coach, fetchCoaches } from '@data';

export const getCoachesKey = () => ['coaches'] as const;

export const useCoaches = () => {
    return useQuery<Coach[]>({
        queryKey: getCoachesKey(),
        queryFn: () => fetchCoaches(supabaseClient),
    });
};
